import { KeyRound, Sparkles } from "lucide-react";
import { APP } from "@/config/app.config";
import { ChangePasswordForm } from "@/modules/auth/ui/components/ChangePasswordForm";

export function ChangePasswordPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4 md:p-10 font-sans overflow-hidden relative">
      {/* Background patterns */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-50 rounded-full blur-3xl -mr-64 -mt-64 opacity-50" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-fuchsia-50 rounded-full blur-3xl -ml-64 -mb-64 opacity-50" />

      <div className="max-w-xl w-full relative z-10">
        <div className="bg-white rounded-2xl p-8 md:p-16 shadow-2xl shadow-gray-200/50 border border-gray-100">
          {/* Header */}
          <div className="mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-50 rounded-full text-amber-600 text-[10px] font-black uppercase tracking-widest mb-6">
              <Sparkles size={14} />
              <span>Sécurité du compte</span>
            </div>
            <h1 className="text-3xl md:text-4xl font-black text-[#003366] leading-[1.1] tracking-tight mb-4">
              Changez votre{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-fuchsia-600 italic">
                mot de passe
              </span>
            </h1>
            <p className="text-gray-400 font-medium text-sm">
              Votre compte utilise un mot de passe temporaire. Veuillez en créer un nouveau pour
              continuer.
            </p>
          </div>

          {/* Form */}
          <ChangePasswordForm />
        </div>

        {/* Security icon */}
        <div className="flex justify-center mt-8">
          <div className="inline-flex items-center gap-2 text-gray-300 text-[10px] font-black uppercase tracking-[0.3em]">
            <KeyRound size={14} />
            <span>Connexion sécurisée</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[10px] font-black text-gray-300 uppercase tracking-[0.3em]">
        © {APP.tagline} 2026
      </div>
    </div>
  );
}
